// SPDX-License-Identifier: MIT

export const DEFAULT_RELAYS = [
  'wss://relay.damus.io',
  'wss://nostr.wine',
  'wss://relay.nostr.net',
  'wss://relay.nostr.band',
  'wss://nos.lol',
  'wss://nostr-pub.wellorder.net',
  'wss://relay.getalby.com',
  'wss://relay.primal.net',
  // 'wss://nostr.malin.onl',
  // 'wss://nostrsatva.net',
] as const;

export const MILLISATS_PER_SAT = 1000;

export const NPUB_LENGTH = 63;

export const DEFAULT_PROFILE_IMAGE = './assets/default_dp.png';
